import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import * as Yup from 'yup';
import { FormValueNames, TagItem } from '../../types/tags-page';

const ABBREVIATION_LENGTH = 3;

export function useCreateTagFormData(activeTag: TagItem | null) {
  const { formatMessage } = useIntl();
  const initialValues = useMemo(() => {
    return {
      [FormValueNames.tagName]: activeTag ? activeTag.name : '',
      [FormValueNames.abbreviation]: activeTag ? activeTag.abbreviation : '',
      [FormValueNames.color]: activeTag ? activeTag.color : '',
      [FormValueNames.settings]: getSettingsValue(activeTag, formatMessage),
    };
  }, [activeTag, formatMessage]);

  const validationSchema = useMemo(() => {
    return Yup.object({
      [FormValueNames.tagName]: Yup.string()
        .required(formatMessage({ id: 'form_required' }))
        .max(255, formatMessage({ id: 'form_text_too_long' })),
      [FormValueNames.abbreviation]: Yup.string()
        .required(formatMessage({ id: 'form_required' }))
        .max(ABBREVIATION_LENGTH, formatMessage({ id: 'form_text_too_long' })),
      [FormValueNames.color]: Yup.string().required(formatMessage({ id: 'form_required' })),
    });
  }, [formatMessage]);

  const settingsOptions = useMemo(() => {
    return [
      {
        label: formatMessage({ id: 'tags_chat' }),
        value: 'chat',
      },
      {
        label: formatMessage({ id: 'tags_videocall' }),
        value: 'videocall',
      },
    ];
  }, [formatMessage]);

  return {
    initialValues,
    validationSchema,
    abbreviationLength: ABBREVIATION_LENGTH,
    settingsOptions,
  };
}

export const twitterPickerStyle = {
  default: {
    card: {
      width: '100%',
    },
    swatch: {
      width: '48px',
      height: '28px',
    },
    input: {
      display: 'none',
    },
    hash: {
      display: 'none',
    },
  },
};

function getSettingsValue(tag: TagItem | null, formatMessage: any) {
  if (!tag || !tag.settings || tag.settings.length === 0) {
    return { value: 'chat', label: formatMessage({ id: 'tags_chat' }) as string };
  }

  return {
    value: tag.settings[0],
    label: formatMessage({ id: 'tags_' + tag.settings[0] }) as string,
  };
}
